<template>
<div>
       <title-blog/>
    <blog-component/> 
</div>

</template>
<script>
import BlogComponent from '../components/BlogList/BlogComponent.vue'
import TitleBlog from '../components/BlogList/Title-blog.vue'
export default {
  components: {BlogComponent , TitleBlog},
    

   }
</script>
<style scoped>

</style>